import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../../components/Button'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import { createCoursesFile, deleteCoursesFile, getCoursesFile, getCoursesFileList } from '../../../actions/courses'
import { useDispatch, useSelector } from 'react-redux'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../../components/Confirmation/Confirmation'

export default function Files({ closeModal, infoCreateChange, setMode }) {

  const { cid } = infoCreateChange || {}

  const dispatch = useDispatch()

  const { coursesFilesList } = useSelector(state => state.courses)
  const { file_list } = coursesFilesList || {}

  const [confirmation, setConfirmation] = useState(false)

  useEffect(() => {
    dispatch(getCoursesFileList(cid))
  }, [])

  const handlePick = () => {
    document.getElementById('filePicker').click()
  }

  const handleChangeFile = (e) => {
    const file = e.target.files[0]
    if (file) dispatch(createCoursesFile(file, cid))
    e.target.value = ''
  }

  const handleDownload = (fileName) => () => {
    dispatch(getCoursesFile(fileName, cid))
  }

  const acceptConfirmation = () => {
    dispatch(deleteCoursesFile(confirmation, cid))
    setConfirmation(false)
  }

  const rejectConfirmation = () => setConfirmation(false)

  const closeFileTab = () => {
    closeModal()
    setMode('main')
  }

  return (
    <>
      <div className={styles.modalMain}>
        {confirmation && <Confirmation
          top="30px"
          left="40px"
          title="Удалить файл?"
          confirmation={confirmation}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation} />}
        <div className={styles.buttons}>
          <Button onClick={handlePick}>+ Файл</Button>
          <input
            className={styles.hidden}
            type='file'
            onChange={handleChangeFile}
            id='filePicker'
          />
        </div>
        <div className={styles.files}>
          {file_list?.map(file => (
            <div className={styles.fileRow} key={file.file_name}>
              <button
                type="button"
                className={styles.fileName}
                onClick={handleDownload(file.file_name)}
                title="Скачать файл"
              >
                {file.file_name}
              </button>
              <button
                type="button"
                className={styles.fileTrash}
                onClick={() => setConfirmation(file.file_name)}
                title="Удалить файл"
                aria-label="Удалить"
              >
                <BiTrash />
              </button>
            </div>
          ))}
        </div>
      </div>
      <ModalFooter closeModal={closeModal} handleSubmit={closeFileTab} infoCreateChange={infoCreateChange} />
    </>
  )
}
